import bar from './charts/bar/bar.js';
import donut from './charts/donut/donut.js';
import legend from './charts/legend/legend.js';
import line from './charts/line/line.js';
import loadingStates from './charts/helpers/load.js';
import tooltip from './charts/tooltip/tooltip.js';
import miniTooltip from './charts/mini-tooltip/mini-tooltip.js';
import sparkline from './charts/sparkline/sparkline.js';
import stackedArea from './charts/stacked-area/stacked-area.js';
import scatterPlot from './charts/scatter-plot/scatter-plot.js';
import groupedBar from './charts/grouped-bar/grouped-bar.js';
import stackedBar from './charts/stacked-bar/stacked-bar.js';
import heatmap from './charts/heatmap/heatmap.js';
import step from './charts/step/step.js';
import brush from './charts/brush/brush.js';
import bullet from './charts/bullet/bullet.js';
import colors from './charts/helpers/color.js';

export {
    bar,
    donut,
    legend,
    line,
    loadingStates,
    tooltip,
    miniTooltip,
    sparkline,
    stackedArea,
    scatterPlot,
    groupedBar,
    stackedBar,
    heatmap,
    step,
    brush,
    bullet,
    colors,
};

const britecharts = {
    bar,
    donut,
    legend,
    line,
    loadingStates,
    tooltip,
    miniTooltip,
    sparkline,
    stackedArea,
    scatterPlot,
    groupedBar,
    stackedBar,
    heatmap,
    step,
    brush,
    bullet,
    colors,
};

export default britecharts;
